import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from 'tss-react/mui';
import UserAssetsContainer from '../../sources/shared/user-assets/UserAssetsContainer';
import LogoAssetImagesLoadMoreCard from './LogoAssetImagesLoadMoreCard';

const styles = theme => ({
    galleryProgress: {
        margin: theme.spacing(4, 0, 4, 0) 
    },
    assetsContentWrapper: {
        padding: theme.spacing(2)
    }
});

const galleryCardWidth = 145;
const galleryCardHeight = 148;

const LogoAssets = ({ logoAssets, logoAssetsCount }) => {
    return (
        <>
            <UserAssetsContainer
                userAssets={logoAssets}
                loadMoreButton={
                    logoAssets.length < logoAssetsCount ?
                        <LogoAssetImagesLoadMoreCard
                            galleryCardHeight={galleryCardHeight}
                            galleryCardWidth={galleryCardWidth}
                        /> : null
                }
            />
        </>
    );
};

const mapStateToProps = (state) => {
    const {
        logoAssets,
        logoAssetsCount
    } = state.mediaPicker;

    return { logoAssets, logoAssetsCount };
}

export default connect(mapStateToProps, {})(withStyles(LogoAssets, styles));